import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const gcrInfoPlugin = createPlugin({
  id: 'gcr-info',
  routes: {
    root: rootRouteRef,
  },
});

export const GcrInfoPage = gcrInfoPlugin.provide(
  createRoutableExtension({
    name: 'GcrInfoPage',
    component: () => import('./components/GcrInfo').then(m => m.GcrInfo),
    mountPoint: rootRouteRef,
  }),
);
